/**
 * Reusable wrapper for embedding an iframe
 */
import { forwardRef } from 'react';

import PropTypes from 'prop-types';

import { getTagsDomain } from '../utils';

export const TagsIframe = forwardRef(({ title, resourcePath }, ref) => {
  const tagsDomain = getTagsDomain();

  return (
    <iframe
      ref={ref}
      title={title}
      src={tagsDomain + resourcePath}
      sandbox="allow-same-origin allow-scripts"
      style={{
        width: 0,
        height: 0,
        border: 0,
        visibility: 'hidden',
        position: 'absolute',
      }}
      loading="lazy"
    />
  );
});

TagsIframe.displayName = 'TagsIframe';

TagsIframe.propTypes = {
  title: PropTypes.string.isRequired,
  resourcePath: PropTypes.string.isRequired,
};
